import { render } from "./Unlicensed.vue?vue&type=template&id=eb453c8c"
import script from "./Unlicensed.vue?vue&type=script&lang=js"
export * from "./Unlicensed.vue?vue&type=script&lang=js"

import "./Unlicensed.vue?vue&type=style&index=0&id=eb453c8c&lang=scss"

import exportComponent from "/home/forge/pa.aneto-apps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__